import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../Translations';

const GoodToKnow: React.FC = () => (
  <div>
    <h3 className="text-base font-semibold text-foreground">
      <T kind="Good to know" />
    </h3>
    <ul className="mt-3 flex list-none flex-col gap-4 rounded-lg border-2 border-dashed border-border bg-secondary p-6">
      <li className="text-sm text-foreground">
        <span className="font-semibold">
          <T kind="Assign access on your side." />
        </span>{' '}
        <T kind="Users can only launch ExecOnline once they (or their group) are assigned to the application in your IdP - set up your access groups now so testing is not blocked later." />
      </li>
      <li className="text-sm text-foreground">
        <span className="font-semibold">
          <T kind="Mobile is supported - keep it working." />
        </span>{' '}
        <T kind="Participants sign in from the ExecOnline mobile app too. Make sure your IdP policies (conditional access, device requirements) allow sign-in from mobile devices." />
      </li>
    </ul>
  </div>
);

export default observer(GoodToKnow);
